import { CloseIcon, DeleteIcon } from "@chakra-ui/icons";
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  Button,
  Divider,
  Flex,
  FormLabel,
  Grid,
  IconButton,
  Popover,
  PopoverArrow,
  PopoverBody,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tooltip,
  Tr,
} from "@chakra-ui/react";
import ShadowBox from "components/common/ShadowBox/ShadowBox";
import TableLoader from "components/common/TableLoader/TableLoader";
import CustomInput from "components/common/customInput/CustomInput";
import { FieldArray } from "formik";
import { FaPlus } from "react-icons/fa";
import { rowStyle, tableIsActive } from "../utils/constant";

const TableForm = ({
  activePage,
  isDisabled,
  values,
  setFieldValue,
  loadFiltersOptions,
  showError,
  data,
  isLoading,
  createWorkflowSettings,
  settingCreateLoading,
}: any) => {
  return (
    <Box display={activePage === 4 ? undefined : "none"}>
      <Flex flexDirection="column">
        <Box>
          <CustomInput
            type="select-async"
            name="table"
            label="Add Existing Table"
            isClear={true}
            getOptionLabel={(option: any) => option.title}
            getOptionValue={(option: any) => option._id}
            loadOptions={(inputValue, callback) =>
              loadFiltersOptions(inputValue, "table", callback)
            }
            onChange={(e) => {
              if (e) {
                if (e.addNew) {
                  setFieldValue("table", [
                    ...values.table,
                    {
                      isActive: true,
                      dateActive: true,
                      filterActive: true,
                      header: {
                        label: e.title,
                        isActive: true,
                      },
                      isPaginate: {
                        paginationLimit: "",
                        isActive: true,
                      },
                      action: {
                        view: false,
                        edit: false,
                        delete: false,
                      },
                      addNew: true,
                      columnName: [
                        {
                          key: "",
                          label: "",
                          isActive: true,
                          sortActive: false,
                          tooltipActive: false,
                          truncatedActive: true,
                          fieldType: "string",
                        },
                      ],
                    },
                  ]);
                } else {
                  if (e) {
                    setFieldValue("table", [
                      ...values.table,
                      { ...e.values, _id: e._id },
                    ]);
                  }
                }
              }
            }}
            options={data}
            loading={isLoading}
            placeholder="Search..."
            disabled={isDisabled}
            rest={{
              width: { base: "10rem", lg: "100%" },
            }}
          />
        </Box>
      </Flex>
      <FieldArray name="table">
        {({ remove }) => (
          <Box>
            {Array.from({ length: values?.table?.length }, (_, indexKey) => (
              <Accordion allowMultiple mt={2}>
                <AccordionItem>
                  <h2>
                    <AccordionButton bg="teal.50" _hover={{ bg: "teal.100" }}>
                      <Box as="span" flex="1" textAlign="left">
                        {values.table[indexKey]?.header?.label}
                      </Box>
                      <AccordionIcon />
                    </AccordionButton>
                  </h2>
                  <AccordionPanel pb={4} px={{ base: 1, lg: 2 }}>
                    <Box
                      shadow={"base"}
                      borderWidth={2}
                      p={5}
                      rounded={8}
                      mt={3}
                    >
                      <Flex justifyContent="flex-end">
                        <Box>
                          <Tooltip
                            label="Delete Table"
                            hasArrow
                            placement="left"
                          >
                            <Button
                              type="button"
                              mt="-8px"
                              color={"red.400"}
                              _hover={{
                                borderColor: "red.500",
                                color: "red.600",
                              }}
                              variant="outline"
                              size="sm"
                              onClick={() => remove(indexKey)}
                              isDisabled={isDisabled}
                              rounded="full"
                              w="1.75rem"
                            >
                              <CloseIcon />
                            </Button>
                          </Tooltip>
                        </Box>
                      </Flex>
                      <Grid
                        columnGap={5}
                        templateColumns={{
                          md: "1fr 1fr 1fr",
                        }}
                        gap={4}
                      >
                        <CustomInput
                          disabled={isDisabled}
                          type="select"
                          options={tableIsActive}
                          label="Show Table"
                          value={values.table[indexKey].isActive}
                          name={`table[${indexKey}].isActive`}
                          onChange={(e: any) =>
                            setFieldValue(`table[${indexKey}].isActive`, e)
                          }
                          isBoxSelect={true}
                        />

                        <CustomInput
                          disabled={isDisabled}
                          type="select"
                          options={tableIsActive}
                          label="Show Pagination"
                          value={values.table[indexKey].isPaginate.isActive}
                          name={`table[${indexKey}].isPaginate.isActive`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].isPaginate.isActive`,
                              e
                            )
                          }
                          isBoxSelect={true}
                        />

                        <CustomInput
                          label="Define Pagination Limit"
                          name={`table[${indexKey}].isPaginate.paginationLimit`}
                          placeholder="Enter the limit"
                          value={
                            values.table[indexKey]?.isPaginate?.paginationLimit
                          }
                          onChange={(e) => {
                            setFieldValue(
                              `table[${indexKey}].isPaginate.paginationLimit`,
                              e.target.value
                            );
                          }}
                          showError={showError}
                          disabled={isDisabled}
                        />
                        {/* <Box display={{ base: "none", md: "block" }}>
                          <Tooltip
                            label="Delete Table"
                            hasArrow
                            placement="left"
                          >
                            <Button
                              type="button"
                              mt="-8px"
                              color={"red.400"}
                              _hover={{
                                borderColor: "red.500",
                                color: "red.600",
                              }}
                              variant="outline"
                              size="sm"
                              onClick={() => remove(indexKey)}
                              isDisabled={isDisabled}
                              rounded={"full"}
                              w="1.75rem"
                            >
                              <CloseIcon />
                            </Button>
                          </Tooltip>
                        </Box> */}

                        {/* </Grid>
                      <Grid
                        columnGap={5}
                        templateColumns={{ md: "1fr 1fr" }}
                        rowGap={4}
                        mt={4}
                      > */}
                        <CustomInput
                          label="Define Header"
                          name={`table[${indexKey}].header.label`}
                          placeholder="Enter the header"
                          value={values.table[indexKey]?.header?.label}
                          onChange={(e) => {
                            setFieldValue(
                              `table[${indexKey}].header.label`,
                              e.target.value
                            );
                          }}
                          showError={showError}
                          disabled={isDisabled}
                        />

                        <CustomInput
                          disabled={isDisabled}
                          type="select"
                          options={tableIsActive}
                          label="Show Header"
                          value={values.table[indexKey]?.header.isActive}
                          name={`table[${indexKey}].header.isActive`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].header.isActive`,
                              e
                            )
                          }
                          isBoxSelect={true}
                        />
                      </Grid>

                      <Divider my={4} borderColor={"gray.300"} />

                      <Grid templateColumns={{ md: "1fr 1fr 1fr 3fr" }} mt={3}>
                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Show Filters"
                          value={values.table[indexKey].filterActive}
                          name={`table[${indexKey}].filterActive`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].filterActive`,
                              e.target.checked
                            )
                          }
                        />

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Show Date Filter"
                          value={values.table[indexKey].dateActive}
                          name={`table[${indexKey}].dateActive`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].dateActive`,
                              e.target.checked
                            )
                          }
                        />
                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Show Search Box"
                          value={values.table[indexKey].searchActive}
                          name={`table[${indexKey}].searchActive`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].searchActive`,
                              e.target.checked
                            )
                          }
                        />
                      </Grid>

                      <Divider my={4} borderColor={"gray.300"} />

                      <Text mt={3} fontWeight="700" color={"teal"}>
                        Define Actions:
                      </Text>
                      <Grid
                        columnGap={5}
                        templateColumns={{
                          md: "1fr 1fr 1fr 1fr 1fr 2fr",
                        }}
                        mt={2}
                      >
                        {/* <Flex alignItems="center">
                          <FormLabel fontSize="sm" mt={4}>
                            View:
                          </FormLabel> */}

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="View"
                          value={values.table[indexKey].action.view}
                          name={`table[${indexKey}].action.view`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].action.view`,
                              e.target.checked
                            )
                          }
                        />
                        {/* </Flex> */}
                        {/* <Flex alignItems="center">
                          <FormLabel fontSize="sm" mt={4}>
                            Edit:
                          </FormLabel> */}

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Edit"
                          value={values.table[indexKey].action.edit}
                          name={`table[${indexKey}].action.edit`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].action.edit`,
                              e.target.checked
                            )
                          }
                        />
                        {/* </Flex> */}
                        {/* <Flex alignItems="center">
                          <FormLabel fontSize="sm" mt={4}>
                            Delete:
                          </FormLabel> */}

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Delete"
                          value={values.table[indexKey].action.delete}
                          name={`table[${indexKey}].action.delete`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].action.delete`,
                              e.target.checked
                            )
                          }
                        />
                        {/* </Flex> */}
                        {/* <Flex alignItems="center">
                          <FormLabel fontSize="sm" mt={4} whiteSpace="nowrap">
                            Download PDF:
                          </FormLabel> */}

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Download PDF"
                          value={values.table[indexKey].action.downloadPDF}
                          name={`table[${indexKey}].action.downloadPDF`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].action.downloadPDF`,
                              e.target.checked
                            )
                          }
                        />
                        {/* </Flex> */}
                        {/* <Flex alignItems="center">
                          <FormLabel fontSize="sm" mt={4} whiteSpace="nowrap">
                            Download Excel:
                          </FormLabel> */}

                        <CustomInput
                          disabled={isDisabled}
                          type="switch"
                          label="Download Excel"
                          value={values.table[indexKey].action.downloadExcel}
                          name={`table[${indexKey}].action.downloadExcel`}
                          onChange={(e: any) =>
                            setFieldValue(
                              `table[${indexKey}].action.downloadExcel`,
                              e.target.checked
                            )
                          }
                        />
                        {/* </Flex> */}
                      </Grid>

                      <Divider my={4} borderColor={"gray.300"} />
                      <Flex justify={"space-between"}>
                        <Flex
                          justifyContent="space-between"
                          alignItems="center"
                          mt={3}
                        >
                          <Text fontWeight="700" color={"teal"}>
                            Define Column Names
                          </Text>
                          {values?.table[indexKey]?.columnName.length === 0 && (
                            <Tooltip
                              label="Add Column"
                              hasArrow
                              placement="left"
                            >
                              <Button
                                onClick={() => {
                                  setFieldValue(
                                    `table[${indexKey}].columnName`,
                                    [
                                      ...values.table[indexKey].columnName,
                                      {
                                        key: "",
                                        label: "",
                                        isActive: true,
                                        isFile: false,
                                        fileView: false,
                                        fileDownload: false,
                                        sortActive: false,
                                        tooltipActive: false,
                                        tooltipLabel: "",
                                        truncatedActive: false,
                                        labelCenter: false,
                                        labelNoWrap: false,
                                        rowType: rowStyle[0],
                                        fieldType: "string",
                                      },
                                    ]
                                  );
                                }}
                                bg="teal.400"
                                color="white"
                                _hover={{ bg: "teal.500" }}
                                disabled={isDisabled}
                              >
                                <FaPlus />
                              </Button>
                            </Tooltip>
                          )}
                        </Flex>

                        <Flex alignItems="baseline">
                          <FormLabel fontSize="sm" whiteSpace="nowrap">
                            Transform to Uppercase:
                          </FormLabel>

                          <CustomInput
                            disabled={isDisabled}
                            type="switch"
                            // label="Delete"
                            value={values.table[indexKey].columnNameUpperCase}
                            name={`table[${indexKey}].columnNameUpperCase`}
                            onChange={(e: any) =>
                              setFieldValue(
                                `table[${indexKey}].columnNameUpperCase`,
                                e.target.checked
                              )
                            }
                          />
                        </Flex>
                      </Flex>

                      <Box
                        mt={3}
                        overflowY="auto"
                        className="customScrollBar"
                        w={{ base: "70vw", md: "78vw", lg: "73vw" }}
                      >
                        <Table>
                          <Thead>
                            <Tr>
                              <Th>Label</Th>
                              <Th>Key</Th>
                              <Th whiteSpace="nowrap">Active Mode</Th>
                              <Th whiteSpace="nowrap">Align label Center</Th>
                              <Th whiteSpace="nowrap">Nowrap Header</Th>
                              <Th whiteSpace="nowrap">Nowrap Row</Th>
                              <Th whiteSpace="nowrap">Row Alignment</Th>
                              <Th>File</Th>
                              {values &&
                                values.table &&
                                values.table[indexKey] &&
                                values.table[indexKey].columnName.some(
                                  (column: any) => column.isFile === true
                                ) && (
                                  <>
                                    <Th whiteSpace="nowrap">View File</Th>
                                    <Th whiteSpace="nowrap">Download File</Th>
                                  </>
                                )}
                              <Th>Sort</Th>
                              <Th>Truncated</Th>
                              <Th></Th>
                            </Tr>
                          </Thead>
                          <FieldArray name={`table[${indexKey}].columnName`}>
                            {({ remove }) => (
                              <TableLoader
                                loader={false}
                                show={values.table[indexKey]?.columnName}
                              >
                                <Tbody>
                                  {values.table[indexKey]?.columnName.map(
                                    (item: any, index: any) => (
                                      <Tr key={index}>
                                        <Td>
                                          <CustomInput
                                            name={`table[${indexKey}].columnName[${index}].label`}
                                            placeholder="Enter the column name"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].label
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].label`,
                                                e.target.value
                                              );
                                            }}
                                            showError={showError}
                                            disabled={isDisabled}
                                            rest={{
                                              width: {
                                                base: "10rem",
                                                lg: "12rem",
                                              },
                                            }}
                                          />
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            name={`table[${indexKey}].columnName[${index}].key`}
                                            placeholder="Enter the column key"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].key
                                            }
                                            onChange={(e) => {
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].key`,
                                                e.target.value
                                              );
                                            }}
                                            showError={showError}
                                            disabled={isDisabled}
                                            rest={{
                                              width: {
                                                base: "10rem",
                                                lg: "12rem",
                                              },
                                            }}
                                          />
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].isActive
                                            }
                                            name={`table[${indexKey}].columnName[${index}].isActive`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].isActive`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].labelCenter
                                            }
                                            name={`table[${indexKey}].columnName[${index}].labelCenter`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].labelCenter`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].labelNoWrap
                                            }
                                            name={`table[${indexKey}].columnName[${index}].labelNoWrap`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].labelNoWrap`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].rowNoWrap
                                            }
                                            name={`table[${indexKey}].columnName[${index}].rowNoWrap`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].rowNoWrap`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          <Box w="7rem">
                                            <CustomInput
                                              disabled={isDisabled}
                                              type="select"
                                              options={rowStyle}
                                              name={`table[${indexKey}].columnName[${index}].rowType`}
                                              value={
                                                values?.table[indexKey]
                                                  .columnName[index].rowType
                                              }
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `table[${indexKey}].columnName[${index}].rowType`,
                                                  e
                                                )
                                              }
                                              isBoxSelect={true}
                                            />
                                          </Box>
                                        </Td>
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].isFile
                                            }
                                            name={`table[${indexKey}].columnName[${index}].isFile`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].isFile`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        {values &&
                                          values.table &&
                                          values.table[indexKey] &&
                                          values.table[
                                            indexKey
                                          ].columnName.some(
                                            (column: any) =>
                                              column.isFile === true
                                          ) &&
                                          (values?.table[indexKey].columnName[
                                            index
                                          ].isFile === true ? (
                                            <>
                                              <Td>
                                                <CustomInput
                                                  disabled={isDisabled}
                                                  type="switch"
                                                  value={
                                                    values?.table[indexKey]
                                                      .columnName[index]
                                                      .fileView
                                                  }
                                                  name={`table[${indexKey}].columnName[${index}].fileView`}
                                                  onChange={(e: any) =>
                                                    setFieldValue(
                                                      `table[${indexKey}].columnName[${index}].fileView`,
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </Td>
                                              <Td>
                                                <CustomInput
                                                  disabled={isDisabled}
                                                  type="switch"
                                                  value={
                                                    values?.table[indexKey]
                                                      .columnName[index]
                                                      .fileDownload
                                                  }
                                                  name={`table[${indexKey}].columnName[${index}].fileDownload`}
                                                  onChange={(e: any) =>
                                                    setFieldValue(
                                                      `table[${indexKey}].columnName[${index}].fileDownload`,
                                                      e.target.checked
                                                    )
                                                  }
                                                />
                                              </Td>
                                            </>
                                          ) : (
                                            <>
                                              <Td></Td>
                                              <Td></Td>
                                            </>
                                          ))}
                                        <Td>
                                          <CustomInput
                                            disabled={isDisabled}
                                            type="switch"
                                            value={
                                              values?.table[indexKey]
                                                .columnName[index].sortActive
                                            }
                                            name={`table[${indexKey}].columnName[${index}].sortActive`}
                                            onChange={(e: any) =>
                                              setFieldValue(
                                                `table[${indexKey}].columnName[${index}].sortActive`,
                                                e.target.checked
                                              )
                                            }
                                          />
                                        </Td>
                                        <Td>
                                          <Flex gap={2} alignItems="center">
                                            <Box w="4rem">
                                              <CustomInput
                                                disabled={isDisabled}
                                                type="switch"
                                                value={
                                                  values?.table[indexKey]
                                                    .columnName[index]
                                                    .truncatedActive
                                                }
                                                name={`table[${indexKey}].columnName[${index}].truncatedActive`}
                                                onChange={(e: any) =>
                                                  setFieldValue(
                                                    `table[${indexKey}].columnName[${index}].truncatedActive`,
                                                    e.target.checked
                                                  )
                                                }
                                              />
                                            </Box>
                                            {values?.table[indexKey].columnName[
                                              index
                                            ].truncatedActive === true && (
                                              <Box w="12rem">
                                                <CustomInput
                                                  name={`table[${indexKey}].columnName[${index}].tooltipLabel`}
                                                  placeholder="Enter the tooltip label"
                                                  value={
                                                    values?.table[indexKey]
                                                      .columnName[index]
                                                      .tooltipLabel
                                                  }
                                                  onChange={(e) => {
                                                    setFieldValue(
                                                      `table[${indexKey}].columnName[${index}].tooltipLabel`,
                                                      e.target.value
                                                    );
                                                  }}
                                                  showError={showError}
                                                  disabled={isDisabled}
                                                />
                                              </Box>
                                            )}
                                          </Flex>
                                        </Td>
                                        <Td>
                                          <Flex alignItems="center">
                                            <Tooltip
                                              label="Delete Column Name"
                                              hasArrow
                                              placement="left"
                                            >
                                              <IconButton
                                                aria-label="Delete"
                                                icon={<DeleteIcon />}
                                                type="button"
                                                size={{ base: "xs", md: "sm" }}
                                                mt="8px"
                                                colorScheme="red"
                                                variant="outline"
                                                // size="sm"
                                                onClick={() => remove(index)}
                                                isDisabled={isDisabled}
                                              />
                                            </Tooltip>
                                            <Popover placement="left">
                                              <PopoverTrigger>
                                                <IconButton
                                                  aria-label="Add"
                                                  size={{
                                                    base: "xs",
                                                    md: "sm",
                                                  }}
                                                  icon={<FaPlus />}
                                                  bg="teal.400"
                                                  ml={5}
                                                  mt="8px"
                                                  color="white"
                                                  _hover={{
                                                    bg: "teal.500",
                                                  }}
                                                  disabled={isDisabled}
                                                />
                                              </PopoverTrigger>
                                              <PopoverContent>
                                                <PopoverArrow />
                                                <PopoverCloseButton />
                                                <PopoverHeader>
                                                  Select Position{" "}
                                                </PopoverHeader>
                                                <PopoverBody>
                                                  <Flex
                                                    alignItems="center"
                                                    justifyContent="center"
                                                    gap={2}
                                                  >
                                                    <Button
                                                      onClick={() => {
                                                        const updatedColumnName =
                                                          [
                                                            ...values.table[
                                                              indexKey
                                                            ].columnName.slice(
                                                              0,
                                                              index
                                                            ),
                                                            {
                                                              key: "",
                                                              label: "",
                                                              isActive: true,
                                                              isFile: false,
                                                              fileView: false,
                                                              fileDownload:
                                                                false,
                                                              sortActive: false,
                                                              tooltipActive:
                                                                false,
                                                              tooltipLabel: "",
                                                              truncatedActive:
                                                                false,
                                                              labelCenter:
                                                                false,
                                                              labelNoWrap:
                                                                false,
                                                              rowType:
                                                                rowStyle[0],
                                                              fieldType:
                                                                "string",
                                                            },
                                                            ...values.table[
                                                              indexKey
                                                            ].columnName.slice(
                                                              index
                                                            ),
                                                          ];
                                                        setFieldValue(
                                                          `table[${indexKey}].columnName`,
                                                          updatedColumnName
                                                        );
                                                      }}
                                                      bg="teal.400"
                                                      color="white"
                                                      _hover={{
                                                        bg: "teal.500",
                                                      }}
                                                    >
                                                      Add Above
                                                    </Button>
                                                    <Button
                                                      onClick={() => {
                                                        const updatedColumnName =
                                                          [
                                                            ...values.table[
                                                              indexKey
                                                            ].columnName.slice(
                                                              0,
                                                              index + 1
                                                            ),
                                                            {
                                                              key: "",
                                                              label: "",
                                                              isActive: true,
                                                              isFile: false,
                                                              fileView: false,
                                                              fileDownload:
                                                                false,
                                                              sortActive: false,
                                                              tooltipActive:
                                                                false,
                                                              tooltipLabel: "",
                                                              truncatedActive:
                                                                false,
                                                              labelCenter:
                                                                false,
                                                              labelNoWrap:
                                                                false,
                                                              rowType:
                                                                rowStyle[0],
                                                              fieldType:
                                                                "string",
                                                            },
                                                            ...values.table[
                                                              indexKey
                                                            ].columnName.slice(
                                                              index + 1
                                                            ),
                                                          ];

                                                        setFieldValue(
                                                          `table[${indexKey}].columnName`,
                                                          updatedColumnName
                                                        );
                                                      }}
                                                      bg="teal.400"
                                                      color="white"
                                                      _hover={{
                                                        bg: "teal.500",
                                                      }}
                                                    >
                                                      Add Below
                                                    </Button>
                                                  </Flex>
                                                </PopoverBody>
                                              </PopoverContent>
                                            </Popover>
                                          </Flex>
                                        </Td>
                                      </Tr>
                                    )
                                  )}
                                </Tbody>
                              </TableLoader>
                            )}
                          </FieldArray>
                        </Table>
                      </Box>

                      <Divider my={4} borderColor={"gray.300"} />


                      <Box  overflowY="auto" className="customScrollBar">
                        <Flex alignItems="end" gap={2}>
                          <Text fontWeight="500"  whiteSpace="nowrap">
                            Define Drawer Table:
                          </Text>
                          <CustomInput
                            disabled={isDisabled}
                            type="switch"
                            value={values?.table[indexKey].drawerTableActive}
                            name={`table[${indexKey}].drawerTableActive`}
                            onChange={(e: any) =>
                              setFieldValue(
                                `table[${indexKey}].drawerTableActive`,
                                e.target.checked
                              )
                            }
                          />
                        </Flex>
                        {values?.table[indexKey].drawerTableActive && (
                          <Table mt={3}>
                            <Thead>
                              <Tr>
                                <Th>Label</Th>
                                <Th whiteSpace="nowrap">Active Mode</Th>
                                <Th whiteSpace="nowrap">Align label Center</Th>
                                <Th whiteSpace="nowrap">Nowrap</Th>
                                <Th whiteSpace="nowrap">Row Alignment</Th>

                                <Th></Th>
                              </Tr>
                            </Thead>
                            <FieldArray name={`table[${indexKey}].drawerTable`}>
                              {({ remove }) => (
                                <TableLoader
                                  loader={false}
                                  show={values.table[indexKey]?.drawerTable}
                                >
                                  <Tbody>
                                    {values.table[indexKey]?.drawerTable.map(
                                      (item: any, index: any) => (
                                        <Tr key={index}>
                                          <Td>
                                            <CustomInput
                                              name={`table[${indexKey}].drawerTable[${index}].label`}
                                              placeholder="Enter the column name"
                                              value={
                                                values?.table[indexKey]
                                                  .drawerTable[index].label
                                              }
                                              onChange={(e) => {
                                                setFieldValue(
                                                  `table[${indexKey}].drawerTable[${index}].label`,
                                                  e.target.value
                                                );
                                              }}
                                              showError={showError}
                                              disabled={isDisabled}
                                              rest={{
                                                width: {
                                                  base: "10rem",
                                                  lg: "12rem",
                                                },
                                              }}
                                            />
                                          </Td>
                                          <Td>
                                            <CustomInput
                                              disabled={isDisabled}
                                              type="switch"
                                              value={
                                                values?.table[indexKey]
                                                  .drawerTable[index].isActive
                                              }
                                              name={`table[${indexKey}].drawerTable[${index}].isActive`}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `table[${indexKey}].drawerTable[${index}].isActive`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </Td>
                                          <Td>
                                            <CustomInput
                                              disabled={isDisabled}
                                              type="switch"
                                              value={
                                                values?.table[indexKey]
                                                  .drawerTable[index]
                                                  .labelCenter
                                              }
                                              name={`table[${indexKey}].drawerTable[${index}].labelCenter`}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `table[${indexKey}].drawerTable[${index}].labelCenter`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </Td>
                                          <Td>
                                            <CustomInput
                                              disabled={isDisabled}
                                              type="switch"
                                              value={
                                                values?.table[indexKey]
                                                  .drawerTable[index]
                                                  .labelNoWrap
                                              }
                                              name={`table[${indexKey}].drawerTable[${index}].labelNoWrap`}
                                              onChange={(e: any) =>
                                                setFieldValue(
                                                  `table[${indexKey}].drawerTable[${index}].labelNoWrap`,
                                                  e.target.checked
                                                )
                                              }
                                            />
                                          </Td>
                                          <Td>
                                            <Box w="7rem">
                                              <CustomInput
                                                disabled={isDisabled}
                                                type="select"
                                                options={rowStyle}
                                                name={`table[${indexKey}].drawerTable[${index}].rowType`}
                                                value={
                                                  values?.table[indexKey]
                                                    .drawerTable[index].rowType
                                                }
                                                onChange={(e: any) =>
                                                  setFieldValue(
                                                    `table[${indexKey}].drawerTable[${index}].rowType`,
                                                    e
                                                  )
                                                }
                                                isBoxSelect={true}
                                              />
                                            </Box>
                                          </Td>
                                          <Td>
                                            <Flex alignItems="center">
                                              <Tooltip
                                                label="Delete Column"
                                                hasArrow
                                                placement="left"
                                              >
                                                <Button
                                                  type="button"
                                                  mt="8px"
                                                  colorScheme="red"
                                                  variant="outline"
                                                  // size="sm"
                                                  onClick={() => {
                                                    remove(index);
                                                  }}
                                                  size={{
                                                    base: "xs",
                                                    md: "sm",
                                                  }}
                                                  isDisabled={isDisabled}
                                                >
                                                  <DeleteIcon />
                                                </Button>
                                              </Tooltip>
                                              {index ===
                                                values?.table[indexKey]
                                                  .drawerTable.length -
                                                  1 && (
                                                <Tooltip
                                                  label="Add Column"
                                                  hasArrow
                                                  placement="left"
                                                >
                                                  <IconButton
                                                    aria-label="Add Column"
                                                    icon={<FaPlus />}
                                                    size={{
                                                      base: "xs",
                                                      md: "sm",
                                                    }}
                                                    onClick={() => {
                                                      setFieldValue(
                                                        `table[${indexKey}].drawerTable`,
                                                        [
                                                          ...values.table[
                                                            indexKey
                                                          ].drawerTable,
                                                          {
                                                            label: "",
                                                            isActive: true,
                                                            rowType:
                                                              rowStyle[0],
                                                            labelCenter: false,
                                                            labelNoWrap: false,
                                                          },
                                                        ]
                                                      );
                                                    }}
                                                    bg="teal.400"
                                                    ml={5}
                                                    mt="8px"
                                                    color="white"
                                                    _hover={{
                                                      bg: "teal.500",
                                                    }}
                                                    disabled={isDisabled}
                                                  />
                                                </Tooltip>
                                              )}
                                            </Flex>
                                          </Td>
                                        </Tr>
                                      )
                                    )}
                                  </Tbody>
                                </TableLoader>
                              )}
                            </FieldArray>
                          </Table>
                        )}
                      </Box>
                      <Flex
                        justifyContent="end"
                        mt={2}
                        display={
                          values?.table[indexKey].addNew ? undefined : "none"
                        }
                      >
                        <Box>
                          <Button
                            bg="green.400"
                            color="white"
                            _hover={{ bg: "green.500" }}
                            mt={4}
                            isLoading={settingCreateLoading}
                            onClick={() =>
                              createWorkflowSettings(
                                indexKey,
                                "table",
                                values,
                                setFieldValue
                              )
                            }
                          >
                            Save
                          </Button>
                        </Box>
                      </Flex>
                    </Box>
                  </AccordionPanel>
                </AccordionItem>
              </Accordion>
            ))}
          </Box>
        )}
      </FieldArray>
    </Box>
  );
};

export default TableForm;
